import React from 'react';
import {Tooltip} from 'react-tippy';
import {Link} from 'react-router-dom';
import {shape, string} from 'prop-types';
import capitalize from 'lodash/capitalize';
import {Grid, Icon, Container, Segment, Image, Label} from 'semantic-ui-react';
import ImagePlaceholder from 'components/images/ImagePlaceholder';
import {makeDBContentImageUrl} from 'utils/DBUtils';

const formatCampaignType = str => str.split('_').map(capitalize).join(' ');

export const UGCCampaignPropType = shape({
  id: string.isRequired,
  name: string,
  title: string,
  exampleImageId: string,
  type: string
});

export default class UGCCampaignItem extends React.Component {
  static propTypes = UGCCampaignPropType;

  static defaultProps = {
    name: `[Not Named]`,
    title: `[No title]`
  };

  state = {
    imageError: false
  };

  handleImageError = event => {
    this.setState({imageError: true});
  };

  render() {
    return (
      <Segment className='ugc-campaign-item-wrapper'>
        <Link to={`/ugc/${this.props.id}`} className='ugc-campaign-item'>
          <Grid>
            <Grid.Column verticalAlign='middle'>
              <Icon name='search' />
            </Grid.Column>
            <Grid.Column verticalAlign='middle' width={3}>
              <Tooltip trigger='mouseenter' followCursor='true' title={this.props.title}>
                {this.props.name}
              </Tooltip>
            </Grid.Column>
            <Grid.Column verticalAlign='middle' width={4}>
              {(!this.props.exampleImageId || this.state.imageError) ? <ImagePlaceholder /> : (
                <Image
                  centered
                  onError={this.handleImageError}
                  src={makeDBContentImageUrl(this.props.exampleImageId).concat('_small')} />
              )}
            </Grid.Column>
            <Grid.Column verticalAlign='middle' width={2}>
              <Container textAlign='center'>
                {this.props.type ? (
                  <Label className='db-ugc-label db-label-hyperlink'>
                    {formatCampaignType(this.props.type)}
                  </Label>
                ) : (
                  <Label className='db-ugc-label db-label-warning'>
                    Unknown
                  </Label>
                )}
              </Container>
            </Grid.Column>
          </Grid>
        </Link>
      </Segment>
    );
  }
};



// WEBPACK FOOTER //
// ./public/pages/UGCModeration/UGCCampaignItem.jsx